/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import SafeBrowsing from '../../components/SafeBrowsing';
import IdentifyWebsite from '../../components/IdentifyWebsite';
import icon1 from '../../../../../../assets/sme/sso/icon1.png';
import icon2 from '../../../../../../assets/sme/sso/icon2.png';
import icon3 from '../../../../../../assets/sme/sso/icon3.png';
import icon4 from '../../../../../../assets/sme/sso/icon4.png';
interface ISection1Props {
  settings: any;
}

const iconMap: Record<number, string> = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
};

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const handleIdentifyWebsiteComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'sme-sso-section2-1');
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-2">
      <SafeBrowsing
        title={paragraphsSettings?.safeBrowsingData.title}
        subTitle={paragraphsSettings?.safeBrowsingData.subTitle}
        description={paragraphsSettings?.safeBrowsingData.description}
        sectionTitle={paragraphsSettings?.safeBrowsingData.sectionTitle}
        sectionDescription={
          paragraphsSettings?.safeBrowsingData.sectionDescription
        }
        slides={paragraphsSettings?.safeBrowsingData.slides}
        icons={iconMap}
      />
      <div className="identify-website-box">
        <IdentifyWebsite
          title={paragraphsSettings?.identifyWebsite?.title}
          subTitle={paragraphsSettings?.identifyWebsite?.subTitle}
          steps={paragraphsSettings?.identifyWebsite?.step}
          onComplete={handleIdentifyWebsiteComplete}
          id="sme-sso-section2-1"
        />
      </div>
    </div>
  );
};

export default Section2;
